/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { FC } from "react"
import { RRButtonFooter } from "../../atoms/roundedrectangle/RRButtonFooter"
import { Spacer, StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { SupportCenterLinks } from "utils/SupportCenterLinks"
import { ZendeskArrowLink } from "../../atoms/links/ZendeskArrowLink"
import { FormattedMessage, useIntl } from "react-intl"

const CarrotCardLockedModule: FC<CarrotCardModuleProps> = ({ isVirtualCard }) => {
  const intl = useIntl()
  return (
    <RoundedRectangle backgroundColor="red-orange-white">
      <RRIconBar
        iconName="icn-carrot-cards"
        iconBackgroundColor="roman-red-40"
        label={<StatusBubble backgroundColor="roman-red" status={intl.formatMessage({ defaultMessage: "Locked" })} />}
      />
      <H3 variant="primary" stack="tiny">
        <FormattedMessage defaultMessage="Carrot Card®" />
      </H3>
      <BodySmall color="black-80">
        {isVirtualCard ? (
          <FormattedMessage defaultMessage="Your virtual card has been locked. Check your email for details or contact us for further assistance." />
        ) : (
          <FormattedMessage defaultMessage="Your card has been locked. Check your email for details or contact us for further assistance." />
        )}
      </BodySmall>

      <Spacer height={0.5} />
      <ZendeskArrowLink supportCenterLink={SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER}>
        <FormattedMessage defaultMessage="How to use your Carrot Card" />
      </ZendeskArrowLink>
      {!isVirtualCard && (
        <>
          <Spacer height={0.25} />
          <ArrowLink to="/talk-to-carrot/sendmessage/stolen">
            <FormattedMessage defaultMessage="Report lost or stolen card" />
          </ArrowLink>
        </>
      )}
      <RRButtonFooter to="/talk-to-carrot/sendmessage/lockedcardsupport" outline>
        <FormattedMessage defaultMessage="Contact Care Team" />
      </RRButtonFooter>
    </RoundedRectangle>
  )
}

export { CarrotCardLockedModule }
